import { useCallback, useEffect, useState } from 'react';
import axiosInstance from 'utils/axiosInterceptors';
import { TProductBrandDetails } from 'utils/types';

const useGetProductBrand = () => {
  const [productBrands, setProductBrands] = useState<TProductBrandDetails[]>(
    []
  );

  const fetchProductBrands = useCallback(async () => {
    try {
      const res = await axiosInstance.get(
        `/api/v1/productBrands?page=1&pageSize=1000`
      );
      setProductBrands(res.data.data);
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    fetchProductBrands();
  }, [fetchProductBrands]);

  return { productBrands };
};

export default useGetProductBrand;
